export const SET_PAGE_TITLE = 'SET_PAGE_TITLE' as const;
export const SET_METHOD = 'SET_METHOD' as const;
